import { registerMutation } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { RouteOptimizationResult } from '@nsc/route-optimization/entities/RouteOptimizationResult.js';
import { assertNexusSchedulingMutationAllowed } from './assert-nexus-scheduling-access.js';
import { runRoutePlanning, writeResultToOTRS } from '../server/index.js';

export const runFullScheduling = registerMutation({
  operationName: 'runFullScheduling',
  type: () => RouteOptimizationResult,
  resolve: () => async (gqlFields: BaseQLSelectionSet<RouteOptimizationResult>) => {
    await assertNexusSchedulingMutationAllowed();
    const result = await runRoutePlanning('manual-run');
    if (!result) return null;
    await writeResultToOTRS(result);
    return result;
  },
  params: [],
});
